module.exports = __webpack_public_path__ + "img/not-verified-prop.5909d382.svg";